/**
 * Validates Email Address
 * @param {string} email
 * @returns {boolean}
 */
export default function isEmailValid(email) {
  const emailRegexp = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

  return emailRegexp.test(email)
}
